import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import { ScoringSystemActions } from '../actions/actions-type.action';

export interface ScoringSystemsState {
    scoringSystems: any[];
    scoringGamePlatforms: any[];
    isLoading: boolean;
    error: BadResponseWithError | null;
}

const initialState: ScoringSystemsState = {
    scoringSystems: [],
    scoringGamePlatforms: [],
    isLoading: false,
    error: null,
};

const reducer = createReducer(
    initialState,

    on(ScoringSystemActions.fetchScoringSystemsRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ScoringSystemActions.fetchScoringSystemsSuccess,
        (state, { payload }) => ({
            ...state,
            scoringSystems: payload.items || [],
            isLoading: false,
        })
    ),
    on(
        ScoringSystemActions.fetchScoringSystemFailure,
        (state, { payload }) => ({
            ...state,
            isLoading: false,
            error: payload,
        })
    ),

    on(ScoringSystemActions.updateScoringSystemRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ScoringSystemActions.updateScoringSystemSuccess, (state, { body }) => ({
        ...state,
        scoringSystems: state.scoringSystems.map((g) =>
            g.id === body.id ? { ...g, ...body } : g
        ),
        isLoading: false,
    })),
    on(
        ScoringSystemActions.updateScoringSystemFailure,
        (state, { payload }) => ({
            ...state,
            isLoading: false,
            error: payload,
        })
    ),

    on(ScoringSystemActions.fetchScoringGamePlatformRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ScoringSystemActions.fetchScoringGamePlatformSuccess,
        (state, { payload }) => ({
            ...state,
            scoringGamePlatforms: payload.items || [],
            isLoading: false,
        })
    ),
    on(
        ScoringSystemActions.fetchScoringGamePlatformFailure,
        (state, { payload }) => ({
            ...state,
            isLoading: false,
            error: payload,
        })
    ),

    on(ScoringSystemActions.updateScoringGamePlatformRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ScoringSystemActions.updateScoringGamePlatformSuccess,
        (state, { body }) => ({
            ...state,
            scoringGamePlatforms: state.scoringGamePlatforms.map((g) =>
                g.id === body.id ? { ...g, ...body } : g
            ),
            isLoading: false,
        })
    ),
    on(
        ScoringSystemActions.updateScoringGamePlatformFailure,
        (state, { payload }) => ({
            ...state,
            isLoading: false,
            error: payload,
        })
    )
);

export const scoringSystemsReduser = (
    state: ScoringSystemsState | undefined,
    action: Action
) => reducer(state, action);
